<div class="toolbar" role="banner">
    <img alt="TibCourier" src="./assets/img/logo.png" />
    <span class="header-spacer"></span>
    <h4>TIBCARGO</h4>
  </div>